export default function convertToSuperscript(characters) {
  const characterMap = {
    a: "ᵃ",
    b: "ᵇ",
    c: "ᶜ",
    d: "ᵈ",
    e: "ᵉ",
    f: "ᶠ",
    g: "ᵍ",
    h: "ʰ",
    i: "ⁱ",
    j: "ʲ",
    k: "ᵏ",
    l: "ˡ",
    m: "ᵐ",
    n: "ⁿ",
    o: "ᵒ",
    p: "ᵖ",
    r: "ʳ",
    s: "ˢ",
    t: "ᵗ",
    u: "ᵘ",
    v: "ᵛ",
    w: "ʷ",
    x: "ˣ",
    y: "ʸ",
    z: "ᶻ",
    0: "⁰",
    1: "¹",
    2: "²",
    3: "³",
    4: "⁴",
    5: "⁵",
    6: "⁶",
    7: "⁷",
    8: "⁸",
    9: "⁹",
    "-": "⁻",
    "—": "⁻",
    "–": "⁻",
    " ": " "
  };
  
  let newString = "";
  
  characters
    .toLowerCase()
    .split("")
    .forEach((character) => {
      if (characterMap[character]) {
        newString += characterMap[character];
      }
  });
      
  return newString;
}


// WEBPACK FOOTER //
// ./src/shared/functions/convertToSuperscript.js